var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { inject as service } from '@ember/service';
import { equal, reads } from '@ember/object/computed';
import { isEqual } from '@ember/utils';
import EmberObject, { computed, set } from '@ember/object';
import { camelize } from '@square/dashboard-utilities/utils/keys';
import Money from '@square/dashboard-money/models/money';
/* eslint-disable ember/no-mixins */
import UserSubscriptionSupport from '@dashboard/user/mixins/user-subscription-support';
/* eslint-enable ember/no-mixins */
let User = (_dec = reads('canMultiunit'), _dec2 = computed('CA', '_isCA', 'userInfo.countryCode'), _dec3 = computed('JP', '_isJP', 'userInfo.countryCode'), _dec4 = computed('_isUS', 'US', 'userInfo.countryCode'), _dec5 = computed('AU', '_isAU', 'userInfo.countryCode'), _dec6 = computed('GB', '_isGB', 'userInfo.countryCode'), _dec7 = equal('countryCode', 'IE'), _dec8 = equal('countryCode', 'ES'), _dec9 = equal('countryCode', 'FR'), _dec10 = equal('countryCode', 'PR'), _dec11 = equal('countryCode', 'VI'), (_class = class User extends EmberObject.extend(UserSubscriptionSupport) {
  constructor(...args) {
    super(...args);
    // pass-in
    _defineProperty(this, "merchantSubunits", []);
    _defineProperty(this, "employeeCount", null);
    /**
     * @deprecated
     * don't use this -- users are **always** multiunit now
     * we need to update existing logic+tests to understand this usecase
     */
    _initializerDefineProperty(this, "isMultiunit", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _defineProperty(this, "_isCA", void 0);
    _defineProperty(this, "_isJP", void 0);
    _defineProperty(this, "_isUS", void 0);
    _defineProperty(this, "_isAU", void 0);
    _defineProperty(this, "_isGB", void 0);
    _initializerDefineProperty(this, "isIE", _descriptor3, this);
    _initializerDefineProperty(this, "isES", _descriptor4, this);
    _initializerDefineProperty(this, "isFR", _descriptor5, this);
    _initializerDefineProperty(this, "isPR", _descriptor6, this);
    _initializerDefineProperty(this, "isVI", _descriptor7, this);
  }
  get isCA() {
    if (this._isCA !== undefined) {
      return this._isCA;
    }
    return isEqual(this.userInfo.countryCode, 'CA');
  }
  set isCA(value) {
    set(this, '_isCA', value);
  }
  get isJP() {
    if (this._isJP !== undefined) {
      return this._isJP;
    }
    return isEqual(this.userInfo.countryCode, 'JP');
  }
  set isJP(value) {
    set(this, '_isJP', value);
  }
  get isUS() {
    if (this._isUS !== undefined) {
      return this._isUS;
    }
    return isEqual(this.userInfo.countryCode, 'US');
  }
  set isUS(value) {
    set(this, '_isUS', value);
  }
  get isAU() {
    if (this._isAU !== undefined) {
      return this._isAU;
    }
    return isEqual(this.userInfo.countryCode, 'AU');
  }
  set isAU(value) {
    set(this, '_isAU', value);
  }
  get isGB() {
    if (this._isGB !== undefined) {
      return this._isGB;
    }
    return isEqual(this.userInfo.countryCode, 'GB');
  }
  set isGB(value) {
    set(this, '_isGB', value);
  }
  static parseBootstrap(hash) {
    const attributes = camelize(hash);
    Object.keys(attributes).forEach(key => {
      const value = attributes[key];
      if (key.endsWith('Cents')) {
        const moneyKey = key.replace('Cents', '');
        const moneyValue = Money.fromCents(value, attributes.currencyCode);
        attributes[moneyKey] = moneyValue;
        delete attributes[key];
      }
    });
    return attributes;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isMultiunit", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isCA", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "isCA"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isJP", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isJP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isUS", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "isUS"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAU", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "isAU"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGB", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "isGB"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isIE", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isES", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isFR", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isPR", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isVI", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { User as default };